// Modelo Compañia para administrador.
export default class Procedure {
    id=""
    name=""
    description=""
    providerQuito=""
    providerGuayaquil=""
}



// WEBPACK FOOTER //
// ./src/model/Procedure.js